import React, { useState } from 'react';
import { FaXmark } from 'react-icons/fa6';
import InputFile from '../inputFile';

export default function ModalReposta({ submit, close }) {
  const [res, setRes] = useState(
    {
      mensagem: '',
      status: 'EM_ANDAMENTO',
      respondidoEm: new Date().getTime(),
      respondidoPor: 'Equipe Mig-PLUS',
      respostaAnexos: [],
    }
  )

  const handleChange = (e) => setRes({...res, [e.target.name]: e.target.value})

  const addAnexo = (anexo) =>{
    setRes({...res, respostaAnexos: [...res.respostaAnexos, anexo]})
  }

  const removeAnexo = (id) => {
    setRes({
      ...res,
      respostaAnexos: res.respostaAnexos.filter(a => a.arquivo !== id)
    })
  }

  return (
    <div className='fixed w-full h-full flex items-center justify-center bg-secondary bg-opacity-60 z-50 top-0 left-0'>
      <div className='bg-white w-2/3 max-h-[80%] rounded p-8 overflow-y-auto'>
        <div className='flex gap-3 flex-col'>
          <div className='flex justify-between items-center text-primary text-xl'>
            <h1 className='font-semibold'>Resposta</h1>
            <span className='hover:cursor-pointer' onClick={() => close(false)}><FaXmark /></span>
          </div>
          <textarea
            name="mensagem"
            id=""
            cols="30"
            rows="10"
            onChange={(e) => handleChange(e)}
            className='border-primary border-2 p-2 rounded'
          ></textarea>
          <div className='flex flex-col gap-2'>
            <span className='font-semibold text-primary'>Anexos:</span>
            {
              res.respostaAnexos.map((anexo, i) => (
                <div className='flex items-center gap-3' key={i}>
                  <span className='font-semibold text-secondary'>
                    {anexo.nomeArquivo}
                  </span>
                  <span className='hover:cursor-pointer text-warning' onClick={() => removeAnexo(anexo.arquivo) }><FaXmark /></span>
                </div>
              ))
            }
            <InputFile name={res.respostaAnexos.length + 1} change={addAnexo} label={'Enviar arquivo'}/>
          </div>
          <div className='flex justify-end'>
            <button className='bg-primary text-white px-4 py-2 rounded' onClick={() => submit(res)}>Enviar</button>
          </div>
        </div>
      </div>
    </div>
  )
};
